/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */

/**
 * * `amount_changed` - Amount Changed
* `date_changed` - Date Changed
* `method_changed` - Method Changed
* `waived` - Waived
* `refunded` - Refunded
* `canceled` - Canceled
* `transaction_succeeded` - Transaction Succeeded
* `transaction_failed` - Transaction Failed
* `transaction_refunded` - Transaction Refunded
 */
export type EntryTypeEnum = typeof EntryTypeEnum[keyof typeof EntryTypeEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EntryTypeEnum = {
  amount_changed: 'amount_changed',
  date_changed: 'date_changed',
  method_changed: 'method_changed',
  waived: 'waived',
  refunded: 'refunded',
  canceled: 'canceled',
  transaction_succeeded: 'transaction_succeeded',
  transaction_failed: 'transaction_failed',
  transaction_refunded: 'transaction_refunded',
} as const;
